import { useParams } from 'react-router-dom';

import { CsvExport } from '@packages/components/csv-export/csv-export';
import { useCsvData } from '@packages/hooks/use-csv-data/use-csv-data';

import type { ScanExclusionType } from '../../add-ip-range-form/add-ip-range-form';

type Props = {
  tableData: Array<ScanExclusionType>;
};

export const TableExportButton = ({ tableData }: Props) => {
  const { scannerId } = useParams<{ scannerId: string }>();
  const exportString = useCsvData(tableData, []);

  return (
    <CsvExport
      variant="secondary"
      data={exportString}
      fileName={`Scan_Exclusion_Export_${scannerId}`}
    />
  );
};
